/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SingleTurnChatLanguageEnum } from './SingleTurnChatLanguageEnum';
import {
  SingleTurnChatLanguageEnumFromJSON,
  SingleTurnChatLanguageEnumFromJSONTyped,
  SingleTurnChatLanguageEnumToJSON,
} from './SingleTurnChatLanguageEnum';
import type { SingleTurnChatProtocolEnum } from './SingleTurnChatProtocolEnum';
import {
  SingleTurnChatProtocolEnumFromJSON,
  SingleTurnChatProtocolEnumFromJSONTyped,
  SingleTurnChatProtocolEnumToJSON,
} from './SingleTurnChatProtocolEnum';

/**
 *
 * @export
 * @interface SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino
 */
export interface SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino {
  /**
   *
   * @type {SingleTurnChatProtocolEnum}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino
   */
  protocol: SingleTurnChatProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino
   */
  name?: string | null;
  /**
   *
   * @type {SingleTurnChatLanguageEnum}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino
   */
  language: SingleTurnChatLanguageEnum;
  /**
   *
   * @type {Date}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino
   */
  endpointUrl: string;
}

/**
 * Check if a given object implements the SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino interface.
 */
export function instanceOfSingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino(
  value: object,
): value is SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  if (!('endpointUrl' in value) || value['endpointUrl'] === undefined) return false;
  return true;
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoFromJSON(
  json: any,
): SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino {
  return SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoFromJSONTyped(json, false);
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino {
  if (json == null) {
    return json;
  }
  return {
    protocol: SingleTurnChatProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    language: SingleTurnChatLanguageEnumFromJSON(json['language']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    endpointUrl: json['endpoint_url'],
  };
}

export function SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAinoToJSON(
  value?: Omit<SingleTurnChatInferencerPolymorphicSingleTurnChatInferencerAino, 'id'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: SingleTurnChatProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    language: SingleTurnChatLanguageEnumToJSON(value['language']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    endpoint_url: value['endpointUrl'],
  };
}
